import { Locations } from '../Constants/Common';

const nonUkLocations = Object.values(Locations).filter(
    (location) => location !== Locations.Uk
);

export const nonUsLocations = Object.values(Locations).filter(
    (location) => location !== Locations.Us
);

export function isAllowedInLocation(
    allowedLocations: string[],
    currentLocation: string
) {
    return (
        !allowedLocations ||
        !location ||
        allowedLocations.some((c) => {
            if (c === Locations.Uk) {
                // if not in nonUkLocations then it is UK
                // we have to do this because 'en' is not set as a default language for UK
                return nonUkLocations.every((l) => l !== currentLocation);
            }
            return c === currentLocation;
        })
    );
}
